import React from 'react';
import { Box, Stack, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

export const Skeleton = () => (
	<Stack space="space.100" grow="hug">
		<Box xcss={sectionHeading} />
		<Box xcss={menuItem} />
		<Box xcss={menuItem} />
		<Box xcss={menuItem} />

		<Box xcss={sectionHeading} />
		<Box xcss={menuItem} />
		<Box xcss={menuItem} />
		<Box xcss={menuItem} />
		<Box xcss={menuItem} />
	</Stack>
);

const sectionHeading = xcss({
	backgroundColor: 'color.skeleton',
	width: '50%',
	height: token('space.200'),
	borderRadius: 'border.radius.100',
	marginTop: 'space.100',
});

const menuItem = xcss({
	backgroundColor: 'color.skeleton',
	height: token('space.400'),
	borderRadius: 'border.radius.100',
});
